goog.require('el8.data.base');
goog.require('el8.data.currUser');
goog.require('el8.data.testCenters');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.reports');
goog.require('el8.ptdata.patients');
goog.require('el8.data.practices');
goog.require('el8.data.physicians');


goog.require('el8.appservice.status');
goog.require('el8.util.print');
goog.require('el8.template.print.activeProblemList');
goog.require('el8.template.print.patientVisitSummary');
goog.require('el8.template.print.currentMedsSummary');
goog.require('el8.template.print.report');
goog.require('el8.model.base');
goog.require('el8.service.tz');


var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.printClinicalSummary = {};


el8.main.printClinicalSummary.init = function(spec) {

    el8.appservice.status.init();

    el8.ptdata.currPatient = el8.ptdata.patients.create(spec.patientObj);
    el8.data.currUser.populate(spec.userObj);
    el8.ptdata.init(spec.ptdata);
    var practice = el8.data.practices.create(spec.practiceObj);

    if (spec.urls) { el8.service.urls.init(spec.urls); }

    /**
     * This isn't ideal, but since this file is due to be
     * reworked to conform with new printouts code format,
     * we go with it as path of least resistance
     */
    el8.ptdata.ptAllergies.setDocumented(spec.documentationStatus.ptAllergies);
    el8.ptdata.ptIntolerances.setDocumented(spec.documentationStatus.ptIntolerances);
    el8.ptdata.ptProblems.setDocumented(spec.documentationStatus.ptProblems);

    /**
     * Print Part 1 -- visit note patient summary
     */
    el8.ptdata.visitNotes.create(spec.visitNoteObj);
    var prescribingPhysician = null;
    if (spec.prescribingPhysicianObj) {
        prescribingPhysician = el8.data.physicians.create(spec.prescribingPhysicianObj);
    }
    $('.print-content', '#part1').replaceWith(
        el8.template.print.patientVisitSummary.content({
            patient: el8.ptdata.currPatient.asSoyMap(),
            practice: practice.asSoyMap(),
            summary: el8.util.keysFromUnderscoreToCamel(spec.visitSummary)
        })
    );

    /**
     * Print Part 2 -- current meds list, allergies, intols
     */
    $('.print-content', '#part2').replaceWith(
        el8.template.print.currentMedsSummary.content({
            patient: el8.ptdata.currPatient.asSoyMap(),
            practice: practice.asSoyMap(),
            prescribingPhysician: prescribingPhysician ? prescribingPhysician.asSoyMap() : null,
            permRxThreads: el8.util.keysFromUnderscoreToCamel(spec.permRxThreads),
            permOtcThreads: el8.util.keysFromUnderscoreToCamel(spec.permOtcThreads),
            tempThreads: el8.util.keysFromUnderscoreToCamel(spec.tempThreads),
            ptAllergies: {
                'isDocumented': el8.ptdata.ptAllergies.isDocumented(),
                'items': el8.ptdata.ptAllergies.all().map(el8.model.toSoyMapFn)
            },
            ptIntols: {
                'isDocumented': el8.ptdata.ptIntolerances.isDocumented(),
                'items': el8.ptdata.ptIntolerances.all().map(el8.model.toSoyMapFn)
            },
            now: el8.service.tz.soyStr(el8.service.tz.now())
        })
    );

    /**
     * Print Part 3 -- active problem list
     */
    $('.print-content', '#part3').replaceWith(
        el8.template.print.activeProblemList.content({
            patient: el8.ptdata.currPatient.asSoyMap(),
            practice: practice.asSoyMap(),
            prescribingPhysician: prescribingPhysician ? prescribingPhysician.asSoyMap() : null,
            now: el8.service.tz.soyStr(el8.service.tz.now()),
            problems: {
                'isDocumentedAsNone': el8.ptdata.ptProblems.isDocumentedAsNone(),
                'items': el8.ptdata.ptProblems.getAllActive().map(el8.model.toSoyMapFn)
            }
        })
    );

    /**
     * Print Part 4 -- recent labs
     */
    var recentLabsInfo = spec.recentLabsInfo;
    for (var i=0; i<recentLabsInfo.length; i++) {
        var report = el8.ptdata.reports.create(recentLabsInfo[i]['report_json']);
        $('#part4').append(
            el8.template.print.report.content({
                patient: el8.ptdata.currPatient.asSoyMap(),
                practice: practice.asSoyMap(),
                report: $.extend(report.asSoyMap(), {
                    /* Hack the soyMap for now. TODO What we want to do here is
                     * just use our generic printout.html and send in direct json
                     * from server, circumventing js models (i.e. our new preferred
                     * model for printing */
                    labCenters: recentLabsInfo[i]['report_json']['lab_centers']
                }),
                now: el8.service.tz.soyStr(el8.service.tz.now())
            })
        );
    }

    el8.util.print.pageSetup();
};
